export const INVALID_PHONE_NUMBER_ENTERED_ERROR_MESSAGE = 'You’ve entered an invalid phone number. Please try again.'

export const customErrorMessages = (message: string) => {
    if (message === 'Integrations API Error - Bad Request - Invalid phone number,Invalid phone number') {
        return INVALID_PHONE_NUMBER_ENTERED_ERROR_MESSAGE
    }
    return message
}
